import React from 'react'
import { Button, Stack, Box, Typography } from '@mui/material'
import colors from '../theme/colors'
import { useTranslation } from "react-i18next"
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ejeFinalizado from "../images/ejeFinalizado.png"
import Parser from 'html-react-parser';

export const EjeFinalizado = ({ cuestion, PreguntaAnterior, backToAxes }) => {

    const { t } = useTranslation()


    return (
        <Stack
            direction={{ md: "column", lg: "column" }}
            justifyContent="center"
            alignItems="center"
            spacing={4}
            className="textCard"
            padding={"2rem"}
        >
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{ flex: 5 }}
            >

                <Stack mb={2}>
                    <Typography variant="h3" color="primary" sx={{ fontWeight: 'bold' }}>
                        {t('cuestion.ejeFinalizadoTitulo')}
                    </Typography>
                </Stack>
                <Box sx={{ width: {xs: '50%', md: '35%', lg: '20%'}, height: 'auto' }}>
                    <img src={ejeFinalizado} alt="Descripción de la imagen" width="100%" height="auto" />
                </Box>
            </Stack>
            <Stack direction="column" alignItems={"center"} spacing={0} sx={{ flex: 4, paddingTop: { xs: '1em', md: '0' } }}>

                <Stack justifyContent={"center"} alignItems={"center"} spacing={3}>

                    <Typography variant="h2" color="primary" sx={{ fontWeight: 'bold' }} >
                        {t('cuestion.consejos')}
                    </Typography>
                    <Box component={Typography} variant="h6" color="primary"
                        sx={{ border: "1px solid " + colors.bgPrimaryLight, borderRadius: '8px', padding: '1em' }}
                    >
                        {Parser(t('Consejos.' + cuestion.modoCuestionario + '.' + cuestion.ejeActual.key))}
                        {/* {Parser(t('Consejos.p.' + cuestion.ejeActual.key))} */}
                    </Box>
                    <Typography variant="h3" color="primary">
                        {t('cuestion.ejeFinalizadoTexto')}
                    </Typography>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} justifyContent={"center"} alignItems={"center"}>
                        <Button
                            disabled={cuestion.porcentajeEje === 0}
                            onClick={() => {
                                PreguntaAnterior(cuestion.pregunta);
                            }}
                            variant="contained"
                            startIcon={<KeyboardArrowLeftIcon sx={{ color: colors.textMain }} />}
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                            {t("cuestion.btnPreguntaAnterior")}
                        </Button>
                        <Button
                            variant="contained"
                            endIcon={<KeyboardArrowRightIcon sx={{ color: colors.textMain }} />}
                            onClick={backToAxes}
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                            {t("cuestion.btnVolver")}
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}
